// extracted by mini-css-extract-plugin
export default {"tips":"Tips_tips__JCLLZ","item":"Tips_item__2zLWz","active":"Tips_active__F6zdW"};